module.exports = __webpack_public_path__ + "img/20.69869857.png";